<div class="flex items-center">
  <input
    id="{{ controlName }}-{{ item.value }}-radio"
    type="radio"
    [value]="item.value"
    class="hidden"
    [formControl]="formControl"
    name="{{ controlName }}"
  />
  <label for="{{ controlName }}-{{ item.value }}-radio" class="flex items-center group">
    <div class="shrink-0">
      @if (formControl && formControl.value !== item.value) {
        <div
          class="rounded-full border border-gray-300 bg-contrast group-hover:border-primary"
          [style.width.px]="circleSize"
          [style.height.px]="circleSize"
        ></div>
      }
      @if (formControl && formControl.value === item.value) {
        <div
          class="rounded-full border border-primary bg-contrast flex items-center justify-center"
          [style.width.px]="circleSize"
          [style.height.px]="circleSize"
        >
          <div
            class="rounded-full bg-primary"
            [style.width.px]="circleSize - 8"
            [style.height.px]="circleSize - 8"
          ></div>
        </div>
      }
    </div>
    <div class="ml-sm text-sm leading-sm text-txt {{ labelClass }}">{{ item.label }}</div>
  </label>
</div>
